import type {
  DocumentResponse,
  CreateDocumentRequest,
  MarkUploadedRequest,
} from '@/types/upload';
import { apiRequest } from './apiClient';

/**
 * Upload API service
 */
export const uploadApi = {
  /**
   * Create a new document and get signed upload URL
   */
  async createDocument(data: CreateDocumentRequest): Promise<DocumentResponse> {
    const result = await apiRequest<{ data: DocumentResponse }>('/admin/upload/create', {
      method: 'POST',
      body: data,
    });

    return result.data;
  },

  /**
   * Mark document as uploaded
   */
  async markAsUploaded(data: MarkUploadedRequest): Promise<void> {
    await apiRequest<void>('/admin/upload/mark-uploaded', {
      method: 'POST',
      body: data,
    });
  },

  /**
   * Get document details
   */
  async getDocument(documentId: number): Promise<DocumentResponse> {
    const result = await apiRequest<{ data: DocumentResponse }>(`/admin/upload/${documentId}`);
    return result.data;
  },
};
